import DOMPurify from "dompurify";

export function cleanHtml(potentiallyUnsafeHtml: string): string {
    return DOMPurify.sanitize(potentiallyUnsafeHtml, { USE_PROFILES: { html: true } });
}
